import React from "react";
import {
  Layer,
  Rectangle,
  Tooltip,
  Sankey,
  ResponsiveContainer,
} from "recharts";

import * as Colors from "../Colors";

function SankeyNode({ x, y, width, height, index, payload, containerWidth }) {
  const isOut = x + width + 6 > containerWidth;
  return (
    <Layer key={`CustomNode${index}`}>
      <Rectangle
        x={x}
        y={y}
        width={width}
        height={height}
        fill={Colors.PURPLE}
        fillOpacity="1"
      />
      <text
        textAnchor={isOut ? "end" : "start"}
        x={isOut ? x - 6 : x + width + 6}
        y={y + height / 2}
        fontSize="14"
        stroke="#333"
      >
        {payload.name}
      </text>
      <text
        textAnchor={isOut ? "end" : "start"}
        x={isOut ? x - 6 : x + width + 6}
        y={y + height / 2 + 13}
        fontSize="12"
        stroke="#333"
        strokeOpacity="0.5"
      >
        {payload.value}
      </text>
    </Layer>
  );
}

export default function SankeyGraph({ data, options }) {
  data = data ? data : [];

  return (
    <ResponsiveContainer width="100%" height="100%">
      <Sankey
        data={data}
        link={{ strokeOpacity: "0.6", stroke: Colors.ORANGE }}
        node={<SankeyNode />}
        nodePading={50}
        margin={{
          left: 125,
          right: 125,
          top: 50,
          bottom: 50,
        }}
      >
        <Tooltip />
      </Sankey>
    </ResponsiveContainer>
  );
}
